import LettersAnimations from "../UI/animations/LettersAnimations.js";
export default function TittleRandomsFood() {
  return (
    <div className="col-start-1 row-start-1 drop-shadow-sm max-md:row-start-1 ">
      <div className="flex flex-row max-lg:mr-24 max-md:mr-0">
        <LettersAnimations
          className="z-10 h-32 max-2xl:h-28 max-xl:h-24  max-lg:h-20"
          src="images/main_letters/letter_r.png"
          alt="letra r"
        />
        <LettersAnimations
          className="ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_a.png"
          alt="letra a"
        />
        <LettersAnimations
          className="z-0 ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_n.png"
          alt="letra n"
        />
        <LettersAnimations
          className="z-10 ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_d.png"
          alt="letra d"
        />
        <LettersAnimations
          className="z-10 ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o.png"
          alt="letra o"
        />
        <LettersAnimations
          className="z-10 ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_m.png"
          alt="letra m"
        />
        <LettersAnimations
          className="z-10 ml-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_s.png"
          alt="letra s"
        />
      </div>
      <div className="flex flex-row">
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_f_blue.png"
          alt="letra f"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o_blue.png"
          alt="letra o"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o_blue.png"
          alt="letra o"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o_blue.png"
          alt="letra o"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o_blue.png"
          alt="letra o"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_o_blue.png"
          alt="letra o"
        />
        <LettersAnimations
          className="mr-[-1.6rem] h-32 max-2xl:h-28 max-xl:h-24 max-lg:h-20"
          src="images/main_letters/letter_d_blue.png"
          alt="letra d"
        />
      </div>
    </div>
  );
}
